{
    "coordinates": [
        37.4396394036586,
        110.62931240832916
    ],
    "tooltip": "Ermaying",
    "title": "Ermaying Formation",
    "country": "China",
    "period": "Triassic",
    "alt": "TODO"
}
